import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { IntegratorRoot, Text, TextAppearance, TextColor, ThemeProvider, WhiteSpace } from '@volkswagen-onehub/components-core';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-vwsa-text',
    template: ''
})
export class VWSATextComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-text--text
    @Input() text = '';
    @Input() weight = 'normal';
    @Input() appearance = 'copy0200';
    @Input() whiteSpace = 'preLine';
    @Input() color = 'primary';
    @Input() className = '';

    ElementToShow = () => (
        <IntegratorRoot>
            <ThemeProvider>
                <Text
                    bold={this.weight == 'bold'}
                    color={TextColor[this.color]}
                    appearance={TextAppearance[this.appearance]}
                    whiteSpace={WhiteSpace[this.whiteSpace]}
                    className={this.className}>
                    {this.text}
                </Text>
            </ThemeProvider>
        </IntegratorRoot>
    );

    constructor(private hostRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('VWSATextComponent.ngOnChanges', changes);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('VWSATextComponent.ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('VWSATextComponent.ngOnDestroy');
        //removed this because it causes delays when navigating
        //find a way to call it async so it doesn't delay navigation        
        //ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }
}
